import { render, staticRenderFns } from "./customer_levels.vue?vue&type=template&id=3d5807b0&scoped=true"
import script from "./customer_levels.vue?vue&type=script&lang=js"
export * from "./customer_levels.vue?vue&type=script&lang=js"
import style0 from "./customer_levels.vue?vue&type=style&index=0&id=3d5807b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5807b0",
  null
  
)

export default component.exports